// extracted by mini-css-extract-plugin
export default {"overlay":"loader_overlay__vB15j","loader":"loader_loader__auLjt","l1":"loader_l1__wGHOK"};